<template>
  <footer class="footer__wrapper text-light-gray full-width-section">
    <div class="footer__container">
      <footer-content />
      <footer-terms />
    </div>
  </footer>
</template>

<script>
import FooterTerms from '@/components/_layout/AFooter/FooterTerms/index.vue'
import FooterContent from '@/components/_layout/AFooter/FooterContent/index.vue'

export default {
  name: 'AFooter',
  components: {
    FooterContent,
    FooterTerms
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.footer__wrapper {
  background-color: $c--coal-black;
  position: relative;

  .footer__container {
    max-width: $desktop-container;

    $padding: (
      $above-desktop-xl: 96px $padding-x-desktop-full-hd 96px,
      $desktop-md: 72px $padding-x-desktop-md,
      $mobile: 32px $padding-x-mobile 64px
    );

    @include setStyleByBreakpoint('padding', $padding);
  }
}
</style>
